import React from 'react';
import { Link } from 'react-router-dom';
import withSub from 'decorators/withSub';

const component = ({ sub }) => (
  <div className="SubNav">
    <h3>
      {sub.first_name} {sub.last_name}{' '}
      {sub.synced_with_att !== undefined && !sub.synced_with_att && (
        <React.Fragment>
          {' '}
          - <span className="text-danger">BYPASSED AT&amp;T</span>
        </React.Fragment>
      )}
    </h3>
    <p className="links">
      <Link to={`/users/${sub.user_profile}/view`}>&larr; Back to User</Link>
    </p>
  </div>
);

export const SubNav = component;
export default withSub(component);
